import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  title: {
    textAlign: 'center',
  },
}));
